export default __webpack_public_path__ + "static/media/apple_store.57ac04da.png";